import KetoAbout from './keto-about';
import KetoAdmin from './keto-admin';
import KetoAdvantages from './keto-advantages';
import KetoBanner from './keto-banner';
import KetoDesign from './keto-design';
import KetoIntro from './keto-intro';
import styles from './keto-page.module.css';
import KetoMobile from './keto-mobile';
import KetoFont from './keto-font';
import KetoIcons from './keto-icons';
import KetoLogo from './keto-logo';
import KetoMerch from './keto-merch';
import KetoContact from './keto-contact';

function KetoPage() {
  return (
    <div className={styles.keto}>
      <KetoIntro />
      <KetoAbout />
      <KetoAdvantages />
      <KetoBanner />
      <KetoMobile />
      <KetoAdmin />
      <KetoDesign />
      <KetoFont />
      <KetoIcons />
      <KetoLogo />
      <KetoMerch />
      <KetoContact />
    </div>
  );
}

export default KetoPage;
